import React from 'react';
import { GenericNodeView } from 'common/components/PreviewApprovalHierarchyReactFlow/NodeView';
import {
  MessagePurchaseOrderCreate,
  MessagePurchaseOrderCreateVariables,
} from 'purchaseOrder/view/FormView/ActionMenu/Messages/NewMessage/__generated__/MessagePurchaseOrderCreate';
import { HierarchyNode } from '../HierarchyComponent/Hierarchy';
import ADD_NEW_MESSAGE from '../../ActionMenu/Messages/NewMessage/MessagePurchaseOrderCreate.graphql';

interface NodeViewProps {
  nodeData: HierarchyNode;
}

export const NodeView: React.FC<NodeViewProps> = ({ nodeData }) => (
  <GenericNodeView<
    HierarchyNode,
    MessagePurchaseOrderCreate,
    MessagePurchaseOrderCreateVariables
  >
    data={nodeData}
    addNewMessageMutation={ADD_NEW_MESSAGE}
    getEntityId={(data) => data.entityId!}
  />
);
